<template>
  <div>
    <div
      v-for="i in $store.state.answer"
      :class="answered(i)"
      @click="linkTo(i.id)"
    >
      <div :class="answered_text(i)">{{ i.id }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Answered',
  methods: {
    answered(val) {
      const bool = this.checkAnswer(val.questions)
      return bool ? 'el_box_active' : 'el_box'
    },
    answered_text(val) {
      const bool = this.checkAnswer(val.questions)
      return bool ? 'el_num_active' : 'el_num'
    },
    checkAnswer(questions) {
      const ans = questions.find(item => {
        return item.answer === 0
      })
      if (!ans) {
        return true
      } else {
        return false
      }
    },
    linkTo(id) {
      this.$router.push({ name: 'problem', params: { id: id } })
    },
  },
}
</script>

<style scoped>
.el_box {
  display: inline-flex;
  width: 94px;
  margin-left: 10px;
  margin-bottom: 10px;
  height: 81px;
  background: #ffffff;
  border: 1px solid #6b6b6b;
  box-sizing: border-box;
}
.el_box_active {
  display: inline-flex;
  width: 94px;
  margin-left: 10px;
  margin-bottom: 10px;
  height: 81px;
  background: #ffa4a4;
  box-sizing: border-box;
}
.el_num {
  position: relative;
  margin: auto;
  font-size: 24px;
}
.el_num_active {
  color: #fff;
  position: relative;
  margin: auto;
  font-size: 24px;
}
</style>
